<div class="tw-px-10 tw-py-8 tw-w-full tw-flex tw-flex-col tw-items-center tw-relative">
  <button class="tw-absolute tw-top-0 tw-right-0 tw-mr-4 tw-mt-4 tw-text-gray-400 hover:tw-text-gray-600 focus:tw-outline-none" (click)="close()">
    <i class="fas fa-times tw-text-xl"></i>
  </button>
  <ng-container *ngIf="!isSuccess; else successTemplate">
    <p class="tw-text-2xl tw-font-semibold tw-text-center tw-mb-2" [innerHTML]="'concierge.main.enter_mobile_phone' | translate"></p>
    <p class="tw-text-gray-400 tw-text-center tw-mb-6 tw-text-xl" [innerHTML]="'concierge.main.demo_description' | translate: { customerName: data.customerName }"></p>
    <input
      type="text"
      [(ngModel)]="phoneNumber"
      placeholder="Ej: +56..."
      class="tw-w-56 tw-border tw-rounded tw-py-2 tw-px-4 tw-mb-4 tw-text-center tw-outline-none"
      [ngClass]="errorMessage ? 'tw-border-red-500 focus:tw-border-red-500' : 'tw-border-gray-300 focus:tw-border-blue-400'"
    />
    <p *ngIf="errorMessage" class="tw-text-red-500 tw-text-sm tw-text-center tw-mb-4">
      {{ errorMessage | translate }}
    </p>
    <mh-core-lib-button
      customClass="!tw-bg-[#0F93CC] hover:!tw-bg-[#0F93CC]-active active:!tw-bg-[#0F93CC] disabled:!tw-bg-main-disabled disabled:!tw-text-font-disabled"
      height="40"
      width="290"
      [isDefault]="true"
      [isDisabled]="!isValidPhone() || isLoading"
      [text]="'concierge.main.save_and_test' | translate"
      (clicked)="onSavePhoneNumber()">
    </mh-core-lib-button>
  </ng-container>

  <ng-template #successTemplate>
    <div class="tw-flex tw-flex-col tw-items-center tw-py-4">
      <div class="tw-w-24 tw-h-24 tw-rounded-full tw-bg-green-500 tw-flex tw-items-center tw-justify-center tw-mb-6">
        <i class="fas fa-check tw-text-white tw-text-5xl"></i>
      </div>
      <p class="tw-text-xl tw-font-semibold tw-text-center tw-text-gray-700 tw-mb-2" [innerHTML]="'concierge.main.number_validated' | translate"></p>
      <p class="tw-text-gray-500 tw-text-center" [innerHTML]="'concierge.main.check_whatsapp' | translate"></p>
    </div>
  </ng-template>
</div>
